module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"Species":"物种","CellNum":"细胞数量"},"en":{"Species":"Species","CellNum":"Cell Number"}}')
  delete Component.options._Ctor
}
